import React from 'react'
import PropTypes from 'prop-types'

import CheckIcon from '@mui/icons-material/Check'

import styled from '@emotion/styled'
import { theme } from '../../themes/theme'

const StepperContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 500;
  width: 100%;
`

const ConnectorLine = styled.div`
  width: 100%;
  height: 1.5px;
  margin: 11px 0 0;
  background: ${theme.colors.inputField.placeholder};
`

const Step = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  position: relative;
  white-space: nowrap;

  @media only screen and (max-width: 600px) {
    white-space: wrap;
    text-align: center;
  }
`

const Circle = styled.div`
  width: 23px;
  height: 23px;
  background: ${props => (props.futurestep === 'true' ? theme.colors.inputField.placeholder : theme.colors.primary)};
  margin: 0 10px;

  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  z-index: 1;

  .MuiSvgIcon-root {
    height: 18px;
    width: 18px;
  }

  ::after {
    content: '';
    position: absolute;
    top: 11px;
    left: calc(50% + 22px);
    height: 1.5px;
    height: ${props => (props.position === 'last' ? '0' : '1.5px')};
    width: calc(50% - 22px);
    background: ${theme.colors.inputField.placeholder};
  }

  ::before {
    content: '';
    position: absolute;
    top: 12px;
    left: 0px;
    transform: translateY(-50%);
    height: ${props => (props.position === 'first' ? '0' : '1.5px')};
    width: calc(50% - 22px);
    background: ${theme.colors.inputField.placeholder};
  }
`

const Label = styled.div`
  color: ${props => props.futurestep === 'true' && theme.colors.inputField.placeholder};
`

function Carousel({ steps, activeStep }) {
  return (
    <StepperContainer>
      {steps.map((label, index) => {
        return (
          <React.Fragment key={label}>
            <Step key={label}>
              <Circle futurestep={(index > activeStep).toString()} position={index === 0 ? 'first' : index === steps.length - 1 ? 'last' : 'middle'}>
                {index >= activeStep ? <>{index + 1}</> : <CheckIcon />}
              </Circle>
              <Label futurestep={(index > activeStep).toString()}>{label}</Label>
            </Step>
            {index !== steps.length - 1 && <ConnectorLine />}
          </React.Fragment>
        )
      })}
    </StepperContainer>
  )
}

Carousel.propTypes = {
  steps: PropTypes.array.isRequired,
  activeStep: PropTypes.number.isRequired
}

export default Carousel
